import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d9d79564"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "running-welfare" }
const _hoisted_2 = { class: "bx running-welfare-box" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "top" }

import PostMenu from '../components/PostMenu.vue';
import MoveActive from '../components/MoveActive.vue';
import PostDetail from '../components/PostDetail.vue';
import Comment from '../components/Comment.vue';
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { ActivityFetch } from '../api/request';
import { formatWrap, formatEmotions } from '../lib';
import { ICircleInfoProps } from '../api/type';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const ids = router?.currentRoute?.value?.query?.id;
const id = Array.isArray(ids) ? ids[0] as string : ids || '';
const postInfo = ref<ICircleInfoProps>();
const getDetail = async () => {
  const res = await ActivityFetch.selCircleDynamicsDetail({ id });
  console.log(res);
  const { body } = res;
  if (res.code !== '00') return;
  try {
    body.extContent = JSON.parse(body.extContent);
  } catch (e) {
    body.extContent = null;
  }
  body.showText2 = false;

  if (body.scText && body.scText.length > 200) {
    body.showText2 = true;
    body.scText2 = body.scText.substring(0, 200);
  }
  body.scText = formatWrap(body.scText);
  body.scText = formatEmotions(body.scText);
  body.scText2 = formatWrap(body.scText2);
  body.scText2 = formatEmotions(body.scText2);

  postInfo.value = res.body;
  await ActivityFetch.usReadOrForward({ readNum: 1, heatType: 3, mappingId: id, type: 1 });
};

onMounted(() => {
  // getUserInfo();
  getDetail();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PostMenu),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(PostDetail, { postInfo: postInfo.value }, null, 8, ["postInfo"])
        ]),
        _createVNode(Comment, {
          praiseList: postInfo.value?.praiseList,
          mappingId: postInfo.value?.mappingId,
          fabulousNum: postInfo.value?.fabulousNum,
          id: _unref(id)
        }, null, 8, ["praiseList", "mappingId", "fabulousNum", "id"])
      ]),
      _createVNode(MoveActive)
    ])
  ]))
}
}

})